module.exports = __webpack_public_path__ + "static/media/Inventor Nastran.2c8edbe6.png";